/**
 * Scroll to Top Module
 * Handles the scroll-to-top button visibility and functionality
 */

export function initScrollToTop(): void {
  const button = document.querySelector<HTMLButtonElement>('.scroll-to-top');
  if (!button) return;

  const scrollThreshold = 300;
  let isVisible = false;
  let ticking = false;

  const toggleButton = (): void => {
    const shouldShow = window.scrollY > scrollThreshold;

    if (shouldShow !== isVisible) {
      isVisible = shouldShow;
      button.classList.toggle('is-visible', shouldShow);
    }

    ticking = false;
  };

  // Throttled scroll handler using requestAnimationFrame
  const onScroll = (): void => {
    if (!ticking) {
      window.requestAnimationFrame(toggleButton);
      ticking = true;
    }
  };

  window.addEventListener('scroll', onScroll, { passive: true });

  // Click handler
  button.addEventListener('click', () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });

    // Set focus to top of page for accessibility
    const skipLink = document.querySelector<HTMLElement>('.skip-link');
    if (skipLink) {
      skipLink.focus({ preventScroll: true });
    }
  });

  // Keyboard support
  button.addEventListener('keydown', (e: KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      button.click();
    }
  });

  // Initial check
  toggleButton();
}
